// extracted by mini-css-extract-plugin
export var attachment = "_m0-a";
export var emailContainer = "_m0-4";
export var emailContentPaddedContainer = "_m0-b";
export var emailHeader = "_m0-6";
export var emailIframe = "_m0-3";
export var emailInfoIcon = "_m0-9";
export var emailShortenedSummary = "_m0-e";
export var infoDropdown = "_m0-0";
export var infoRowBoundedContent = "_m0-d";
export var internal = "_m0-5";
export var merchant = "_m0-8";
export var messageInputContainer = "_m0-h";
export var normal = "_m0-7";
export var replyCard = "_m0-f";
export var subtleButton = "_m0-1";
export var subtleButtonIconContainer = "_m0-2";
export var toggleViewRepliesButton = "_m0-c";
export var wrappingText = "_m0-g";